// Ticket-Filter „Hausmeister / Dienstleister“: wer hat das Ticket außer Haus?
// Hausmeister = Freigabe in ticket_hausmeister, Dienstleister = Beauftragung (tickets.dienstleister_id).
// Werte: 'alle' · 'extern' (irgendwer) · 'keine' · 'hm' / 'dl' (alle Hausmeister- bzw. DL-Tickets) · 'hm:<id>' / 'dl:<id>'.

export interface Person { id: string; name: string }
export interface ExternZuordnung { hausmeister: Person[]; dienstleister: Person | null }
export type ExternKarte = Map<string, ExternZuordnung>;

export function baueExternKarte(
  freigaben: readonly { ticket_id: string; hausmeister_id: string }[],
  hausmeisterNamen: ReadonlyMap<string, string>,
  tickets: readonly { id: string; dienstleister_id?: string | null }[],
  dienstleisterNamen: ReadonlyMap<string, string>,
): ExternKarte {
  const karte: ExternKarte = new Map();
  const eintrag = (id: string) => {
    let e = karte.get(id);
    if (!e) { e = { hausmeister: [], dienstleister: null }; karte.set(id, e); }
    return e;
  };
  for (const f of freigaben) {
    const e = eintrag(f.ticket_id);
    if (!e.hausmeister.some(h => h.id === f.hausmeister_id)) e.hausmeister.push({ id: f.hausmeister_id, name: hausmeisterNamen.get(f.hausmeister_id) || 'Hausmeister' });
  }
  for (const t of tickets) {
    if (t.dienstleister_id) eintrag(t.id).dienstleister = { id: t.dienstleister_id, name: dienstleisterNamen.get(t.dienstleister_id) || 'Dienstleister' };
  }
  return karte;
}

export function passtExtern(filter: string, z: ExternZuordnung | undefined): boolean {
  if (!filter || filter === 'alle') return true;
  const hm = z?.hausmeister ?? [];
  const dl = z?.dienstleister ?? null;
  if (filter === 'keine') return hm.length === 0 && !dl;
  if (filter === 'extern') return hm.length > 0 || !!dl;
  if (filter === 'hm') return hm.length > 0;
  if (filter === 'dl') return !!dl;
  if (filter.startsWith('hm:')) return hm.some(h => h.id === filter.slice(3));
  if (filter.startsWith('dl:')) return dl?.id === filter.slice(3);
  return true;
}

export interface ExternOptionen { hausmeister: (Person & { anzahl: number })[]; dienstleister: (Person & { anzahl: number })[] }

/** Auswahl für den Filter: alle vorkommenden Hausmeister/Dienstleister mit Anzahl Tickets (nur betrachtete Tickets). */
export function externOptionen(karte: ExternKarte, ticketIds: readonly string[]): ExternOptionen {
  const hm = new Map<string, Person & { anzahl: number }>();
  const dl = new Map<string, Person & { anzahl: number }>();
  for (const id of ticketIds) {
    const z = karte.get(id);
    if (!z) continue;
    for (const h of z.hausmeister) hm.set(h.id, { ...h, anzahl: (hm.get(h.id)?.anzahl ?? 0) + 1 });
    if (z.dienstleister) dl.set(z.dienstleister.id, { ...z.dienstleister, anzahl: (dl.get(z.dienstleister.id)?.anzahl ?? 0) + 1 });
  }
  const sortiert = (m: Map<string, Person & { anzahl: number }>) => [...m.values()].sort((a, b) => a.name.localeCompare(b.name, 'de'));
  return { hausmeister: sortiert(hm), dienstleister: sortiert(dl) };
}
